import React, { useState } from 'react';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import useClipboard from "react-use-clipboard";

function App() {
  const[textToCopy,setTextToCopy] = useState();
  const [isCopied, setCopied] = useClipboard(textToCopy, {
    successDuration:9000
});
  const startListening = () => SpeechRecognition.startListening({continuous: true,language: 'en-IN'});
  const stopListening = () => SpeechRecognition.stopListening;
  const {transcript,browserSupportsSpeechRecognition} = useSpeechRecognition();

  if (!browserSupportsSpeechRecognition) {
    return <span>Browser doesn't support speech recognition.</span>;
  }

  return (
    <div className="text-3xl h-screen border border-orange-700 ">
      <div className='flex justify-center self-center flex-col mt-[20px]'>
          <h1 className='text- font-bold mt-1 text-center'>Speech to Text</h1>
          
          <p className='flex justify-center items-center self-center text-xl max-w-3xl text-center'>A React hook that converts speech from the microphone to text and makes it available to your React components.</p>
          <div className='max-w-3xl text-center w-full min-h-[400px] border  flex justify-center items-center self-center shadow-2xl bg-[#f3e8ff] rounded-lg ' onClick={ () =>  setTextToCopy(transcript)}>{transcript}</div>
          <div className='flex justify-between max-w-3xl ml-64'>
            <button className='border rounded-md bg-blue-400 px-[32px] hover:bg-blue-900 mt-1 shadow' onClick={setCopied}>{isCopied ? 'Copied!' : 'Copy to clipboard'}</button>
            <button className='border rounded-md bg-blue-400 px-[32px] hover:bg-blue-900 mt-1 shadow' onClick={startListening}>Start</button>
            <button className='border rounded-md bg-blue-400 px-[32px] hover:bg-blue-900 mt-1 shadow' onClick={stopListening}>Stop</button>
          </div>
      </div>
    </div>
  );
}

export default App;
